import { createRouter, createWebHistory } from "vue-router";

// --- START common components ---
const Login = () => import("./components/login/Login.vue");
const ForgotPasswordForm = () =>
	import("./components/login/ForgotPasswordForm.vue");
const ResetPassword = () => import("./components/login/ResetPassword.vue");
const Logout = () => import("./components/Logout.vue");
const Index = () => import("./components/Index.vue");
// --- END common components ---

// --- START Sentinel components ---
const AssetsFullMap = () =>
	import("./components/sentinel-components/app-components/assets-full-map/AssetsFullMap.vue");

const AssetInfo = () =>
	import("./components/sentinel-components/app-components/asset/info/AssetInfo.vue");
const NewAsset = () =>
	import("./components/sentinel-components/app-components/asset/new-asset/NewAsset.vue");
const RemoveAsset = () =>
	import("./components/sentinel-components/app-components/asset/RemoveAsset.vue");
const SystemAssets = () =>
	import("./components/sentinel-components/app-components/assets-dashboard/SystemAssets.vue");
const AssetSystems = () =>
	import("./components/sentinel-components/app-components/assets-dashboard/AssetSystems.vue");

const Asset = () =>
	import("./components/sentinel-components/app-components/asset/Asset.vue");
const AssetEnergyDataMainPanel = () =>
	import("./components/sentinel-components/app-components/asset/energy-data-main-panel/AssetEnergyDataMainPanel.vue");
const AssetEnergyDataMainPanelMeasurements = () =>
	import("./components/sentinel-components/app-components/asset/energy-data-main-panel/AssetEnergyDataMainPanelMeasurements.vue");
const AssetEnergyDataMainPanelWeather = () =>
	import("./components/sentinel-components/app-components/asset/energy-data-main-panel/AssetEnergyDataMainPanelWeather.vue");
const AssetEnergyDataMainPanelSavings = () =>
	import("./components/sentinel-components/app-components/asset/energy-data-main-panel/savings/AssetEnergyDataMainPanelSavings.vue");

const User = () =>
	import("./components/sentinel-components/app-components/user/User.vue");
const UserSettings = () =>
	import("./components/sentinel-components/app-components/user/settings/UserSettings.vue");
const TicketingSettings = () =>
	import("./components/sentinel-components/app-components/user/ticketing/TicketingSettings.vue");
const EnergyProvidersAuth = () =>
	import("./components/sentinel-components/app-components/user/energy-providers-auths/EnergyProvidersAuth.vue");
const EnergyProvidersAuthNew = () =>
	import("./components/sentinel-components/app-components/user/energy-providers-auths/EnergyProvidersAuthNew.vue");
const EnergyProvidersAuthEdit = () =>
	import("./components/sentinel-components/app-components/user/energy-providers-auths/EnergyProvidersAuthEdit.vue");
const EmailNotificationsSettings = () =>
	import("./components/sentinel-components/app-components/user/EmailNotificationsSettings.vue");

const AssetsGroupsConfig = () =>
	import("./components/sentinel-components/app-components/user/assets-groups-config/AssetsGroupsConfig.vue");
const NewAssetsGroup = () =>
	import("./components/sentinel-components/app-components/user/assets-groups-config/NewAssetsGroup.vue");
const EditAssetsGroup = () =>
	import("./components/sentinel-components/app-components/user/assets-groups-config/EditAssetsGroup.vue");
const RemoveAssetsGroup = () =>
	import("./components/sentinel-components/app-components/user/assets-groups-config/RemoveAssetsGroup.vue");

const OwnedUsers = () =>
	import("./components/sentinel-components/app-components/user/users/Users.vue");
const OwnedUserView = () =>
	import("./components/sentinel-components/app-components/user/users/view/UserView.vue");
const OwnedUserAdd = () =>
	import("./components/sentinel-components/app-components/user/users/UserAdd.vue");
const OwnedUserEdit = () =>
	import("./components/sentinel-components/app-components/user/users/UserEdit.vue");
const OwnedUserRemove = () =>
	import("./components/sentinel-components/app-components/user/users/UserRemove.vue");
const OwnedUserResetPassword = () =>
	import("./components/sentinel-components/app-components/user/users/UserResetPassword.vue");

const UserEnergySystems = () =>
	import("./components/sentinel-components/app-components/user/energy-systems/UserEnergySystems.vue");
const UserEnergySystem = () =>
	import("./components/sentinel-components/app-components/user/energy-systems/UserEnergySystem.vue");
const EnergySystemEdit = () =>
	import("./components/sentinel-components/app-components/user/energy-systems/edit/EnergySystemEdit.vue");
const EnergySystemEditGenerationData = () =>
	import("./components/sentinel-components/app-components/user/energy-systems/edit/generation-data/EnergySystemEditGenerationData.vue");
const EnergySystemEditConsumptionData = () =>
	import("./components/sentinel-components/app-components/user/energy-systems/edit/consumption-data/EnergySystemEditConsumptionData.vue");
const EnergySystemEditMonthlyData = () =>
	import("./components/sentinel-components/app-components/user/energy-systems/edit/EnergySystemEditMonthlyData.vue");
const EnergySystemDevices = () =>
	import("./components/sentinel-components/app-components/user/energy-systems/edit/devices/EnergySystemDevices.vue");
const EnergyDeviceModeConfig = () =>
	import("./components/sentinel-components/app-components/user/energy-systems/edit/devices/mode-config/EnergyDeviceModeConfig.vue");
const EnergyMeasurementsTabs = () =>
	import("./components/sentinel-components/app-components/user/energy-systems/edit/EnergyMeasurementsTabs.vue");

const EnergySystemWithProviderCreate = () =>
	import("./components/sentinel-components/app-components/user/energy-systems/create/EnergySystemWithProviderCreate.vue");
const EnergySystemCreate = () =>
	import("./components/sentinel-components/app-components/user/energy-systems/create/EnergySystemCreate.vue");
const EnergySystemsRemove = () =>
	import("./components/sentinel-components/app-components/user/energy-systems/EnergySystemsRemove.vue");

const Ticketing = () =>
	import("./components/sentinel-components/app-components/ticketing/Ticketing.vue");
const Ticket = () =>
	import("./components/sentinel-components/app-components/ticketing/Ticket.vue");
const TicketRemove = () =>
	import("./components/sentinel-components/app-components/ticketing/TicketRemove.vue");
const TicketView = () =>
	import("./components/sentinel-components/app-components/ticketing/TicketView.vue");

const Alerts = () =>
	import("./components/sentinel-components/app-components/alerts/Alerts.vue");
const AssetReports = () =>
	import("./components/sentinel-components/app-components/reports/asset-reports/AssetReports.vue");
const AssetReport = () =>
	import("./components/sentinel-components/app-components/reports/asset-reports/AssetReport.vue");
const AssetReportsRemove = () =>
	import("./components/sentinel-components/app-components/reports/asset-reports/AssetReportsRemove.vue");

const PrTool = () =>
	import("./components/sentinel-components/app-components/pr-tool/PrTool.vue");

//Sentinel - Small device components
const AssetMainPanel = () =>
	import("./components/sentinel-components/small-device-components/asset-main-panel/AssetMainPanel.vue");

//Sentinel - Asset energy panel with no login
const AssetEnergyPanel = () =>
	import("./components/sentinel-components/asset-energy-panel/AssetEnergyPanel.vue");

//Sentinel - Report viewer with no login
const ReportViewer = () =>
	import("./components/sentinel-components/report-viewer/ReportViewer.vue");
// --- END Sentinel components ---

// --- START admin components ---
const AdminUsers = () =>
	import("./components/admin-components/admin/Users.vue");
const AdminNewUser = () =>
	import("./components/admin-components/admin/AdminNewUser.vue");
const UserApiKey = () =>
	import("./components/admin-components/admin/UserApiKey.vue");
const UserEdit = () =>
	import("./components/admin-components/admin/user-edit/UserEdit.vue");
const AdminUserRemove = () =>
	import("./components/admin-components/admin/user-edit/UserRemove.vue");
const AdminUserEnergySystems = () =>
	import("./components/admin-components/admin/user-edit/user-energy-systems/AdminUserEnergySystems.vue");
const AdminUserConfigEdit = () =>
	import("./components/admin-components/admin/user-edit/user-config-edit/AdminUserConfigEdit.vue");
const AdminUi = () =>
	import("./components/admin-components/admin/ui/AdminUi.vue");
// --- END admin components ---

// --- START 2Grid components ---
const GridSystemMainPanel = () =>
	import("./components/grid-components/grid-system-main-panel/GridSystemMainPanel.vue");
const GridSystemEdit = () =>
	import("./components/grid-components/grid-system-edit/GridSystemEdit.vue");
// --- END 2Grid components ---

// --- START BESS components ---
const BessSystemMainPanel = () =>
	import("./components/bess-components/bess-system-main-panel/BessSystemMainPanel.vue");
const BessSystemCreate = () =>
	import("./components/bess-components/bess-system/BessSystemCreate.vue");
const BessSystemDelete = () =>
	import("./components/bess-components/bess-system/BessSystemDelete.vue");
const BessSystemDataUpdate = () =>
	import("./components/bess-components/bess-system/BessSystemDataUpdate.vue");
const BessAssetCreate = () =>
	import("./components/bess-components/bess-asset/BessAssetCreate.vue");
const BessAssetDelete = () =>
	import("./components/bess-components/bess-asset/BessAssetDelete.vue");
const BessAssetUpdate = () =>
	import("./components/bess-components/bess-asset/BessAssetUpdate.vue");
const BessAssetMainPanel = () =>
	import("./components/bess-components/bess-asset/main-panel/BessAssetMainPanel.vue");
const BessAssetMeasurements = () =>
	import("./components/bess-components/bess-asset/main-panel/BessAssetMeasurements.vue");
const BessAlerts = () =>
	import("./components/bess-components/alerts/BessAlerts.vue");
// --- END BESS components ---

const routes = [
	{
		path: "/login",
		name: "login",
		component: Login,
		children: [
			{
				path: "/forgot-password",
				name: "forgot-password",
				component: ForgotPasswordForm
			}
		]
	},
	{
		path: "/reset-password",
		name: "reset-password",
		component: ResetPassword
	},
	{
		path: "/logout",
		name: "logout",
		component: Logout
	},
	{
		path: "/",
		name: "app",
		default: true, // indicate if it's the default route
		component: Index,
		children: [
			// --- START Sentinel routes ---
			{
				name: "full-map",
				path: "full-map",
				component: AssetsFullMap
			},
			{
				name: "new-asset",
				path: "new-asset",
				component: NewAsset
			},
			{
				name: "remove-asset",
				path: "remove-asset/:asset_id",
				component: RemoveAsset
			},
			{
				name: "system-assets",
				path: "system-assets/:system_id",
				component: SystemAssets
			},
			{
				name: "asset-systems",
				path: "asset-systems/:asset_id",
				component: AssetSystems
			},
			{
				name: "asset",
				path: "asset/:asset_id",
				component: Asset,
				children: [
					{
						name: "asset-main-panel",
						path: "main-panel",
						component: AssetEnergyDataMainPanel,
						children: [
							{
								name: "asset-main-panel-measurements",
								path: "measurements",
								component: AssetEnergyDataMainPanelMeasurements
							},
							{
								name: "asset-main-panel-weather",
								path: "weather",
								component: AssetEnergyDataMainPanelWeather
							},
							{
								name: "asset-main-panel-savings",
								path: "savings",
								component: AssetEnergyDataMainPanelSavings
							}
						]
					},
					{
						name: "asset-info",
						path: "asset-info",
						component: AssetInfo
					}
				]
			},
			{
				name: "user",
				path: "/user",
				component: User,
				children: [
					{
						name: "user-settings",
						path: "settings",
						component: UserSettings
					},
					{
						name: "ticketing-settings",
						path: "ticketing-settings",
						component: TicketingSettings
					},
					{
						name: "email-notifications-settings",
						path: "email-notifications-settings",
						component: EmailNotificationsSettings
					},
					{
						name: "user-providers",
						path: "providers",
						component: EnergyProvidersAuth,
						children: [
							{
								name: "user-energy-data-provider-new",
								path: "new",
								component: EnergyProvidersAuthNew
							},
							{
								name: "user-energy-data-provider-edit",
								path: ":auth_id/update",
								component: EnergyProvidersAuthEdit
							}
						]
					},
					{
						name: "owned-users",
						path: "users",
						component: OwnedUsers,
						children: [
							{
								name: "owned-user-view",
								path: ":role/:user_id/view",
								component: OwnedUserView
							},
							{
								name: "owned-user-add",
								path: ":role/add",
								component: OwnedUserAdd
							},
							{
								name: "owned-user-edit",
								path: ":role/edit/:user_id",
								component: OwnedUserEdit
							},
							{
								name: "owned-user-remove",
								path: ":role/remove/:user_id",
								component: OwnedUserRemove
							},
							{
								name: "owned-user-reset-password",
								path: ":role/reset-password/:user_id",
								component: OwnedUserResetPassword
							}
						]
					},
					{
						name: "user-energy-systems",
						path: "user-energy-systems",
						component: UserEnergySystems,
						children: [
							{
								name: "user-energy-system",
								path: ":system_id",
								component: UserEnergySystem
							},
							{
								name: "user-energy-system-update",
								path: ":system_id/update",
								component: EnergySystemEdit,
								children: [
									{
										name: "energy-system-edit-generation-data",
										path: "generation-data",
										component: EnergySystemEditGenerationData
									},
									{
										name: "energy-system-edit-consumption-data",
										path: "consumption-data",
										component: EnergySystemEditConsumptionData
									},
									{
										name: "energy-system-edit-monthly-data",
										path: "monthly-data",
										component: EnergySystemEditMonthlyData
									},
									{
										name: "energy-system-edit-energy-devices",
										path: "devices",
										component: EnergySystemDevices,
										children: [
											{
												name: "device-mode-config",
												path: ":device_id/mode-config",
												component: EnergyDeviceModeConfig
											}
										]
									},
									{
										name: "energy-measurements-tabs",
										path: "measurements",
										component: EnergyMeasurementsTabs
									}
								]
							},
							{
								name: "add-energy-system-with-provider",
								path: "add-energy-system-with-provider",
								component: EnergySystemWithProviderCreate
							},
							{
								name: "add-energy-system",
								path: "add",
								component: EnergySystemCreate
							},
							{
								name: "remove-energy-systems",
								path: "remove",
								component: EnergySystemsRemove
							}
						]
					},
					{
						name: "assets-group-config",
						path: "assets-group-config",
						component: AssetsGroupsConfig,
						children: [
							{
								name: "new-assets-group",
								path: "new",
								component: NewAssetsGroup
							},
							{
								name: "edit-assets-group",
								path: ":assets_group_id/edit",
								component: EditAssetsGroup
							},
							{
								name: "remove-assets-group",
								path: ":assets_group_id/remove",
								component: RemoveAssetsGroup
							}
						]
					}
				]
			},
			{
				name: "ticketing",
				path: "/ticketing",
				component: Ticketing,
				children: [
					{
						name: "new-ticket",
						path: "new",
						component: Ticket
					},
					{
						name: "edit-ticket",
						path: "ticket/:ticket_id/edit",
						component: Ticket
					},
					{
						name: "remove-ticket",
						path: "ticket/:ticket_id/remove",
						component: TicketRemove
					},
					{
						name: "view-ticket",
						path: "ticket/:ticket_id/view",
						component: TicketView
					}
				]
			},
			{
				name: "alerts",
				path: "/alerts",
				component: Alerts
			},
			{
				name: "assets-reports",
				path: "assets-reports",
				component: AssetReports,
				children: [
					{
						name: "new-asset-report",
						path: "new-asset-report",
						component: AssetReport
					},
					{
						name: "view-asset-report",
						path: "asset-report/:asset_report_id",
						component: AssetReport
					},
					{
						name: "remove-asset-reports",
						path: "remove",
						component: AssetReportsRemove
					}
				]
			},
			{
				name: "pr-tool",
				path: "pr-tool",
				component: PrTool
			},
			//mobile routes
			{
				name: "mobile-asset-main-panel",
				path: "/mobile/asset/:asset_id/main-panel",
				component: AssetMainPanel
			},
			// --- END Sentinel routes ---

			// --- START admin routes ---
			{
				name: "admin-users",
				path: "users",
				component: AdminUsers,
				children: [
					{
						name: "admin-new-user",
						path: "new-user",
						component: AdminNewUser
					},
					{
						name: "admin-user-api-key",
						path: ":user_id/admin-user-api-key",
						component: UserApiKey
					},
					{
						name: "admin-user-edit",
						path: ":user_id/edit",
						component: UserEdit,
						children: [
							{
								name: "admin-user-config-edit",
								path: "user",
								component: AdminUserConfigEdit
							},
							{
								name: "admin-user-energy-systems",
								path: "energy-systems",
								component: AdminUserEnergySystems
							}
						]
					},
					{
						name: "admin-user-remove",
						path: ":user_id/remove",
						component: AdminUserRemove
					}
				]
			},
			{
				name: "admin-ui",
				path: "ui",
				component: AdminUi
			},
			// --- END admin routes ---

			// --- START 2grid routes ---
			{
				name: "grid-system-main-panel",
				path: "/grid-system/:grid_system_id/main-panel",
				component: GridSystemMainPanel
			},
			{
				name: "grid-system-edit",
				path: "/grid-system/:grid_system_id",
				component: GridSystemEdit
			},
			// --- END 2grid routes ---

			// --- START BESS routes ---
			{
				name: "bess-system-create",
				path: "/bess/system/create",
				component: BessSystemCreate
			},
			{
				name: "bess-system-delete",
				path: "/bess/system/:bess_system_id/delete",
				component: BessSystemDelete
			},
			{
				name: "bess-system-main-panel",
				path: "/bess/system/:bess_system_id/main-panel",
				component: BessSystemMainPanel
			},
			{
				name: "bess-system-data",
				path: "/bess/system/:bess_system_id/data",
				component: BessSystemDataUpdate
			},
			{
				name: "bess-asset-create",
				path: "/bess/asset/create",
				component: BessAssetCreate
			},
			{
				name: "bess-asset-delete",
				path: "/bess/asset/:bess_asset_id/delete",
				component: BessAssetDelete
			},
			{
				name: "bess-asset-update",
				path: "/bess/asset/:bess_asset_id/update",
				component: BessAssetUpdate
			},
			{
				name: "bess-asset-main-panel",
				path: "/bess/asset/:bess_asset_id/main-panel",
				component: BessAssetMainPanel,
				children: [
					{
						name: "bess-asset-measurements",
						path: "measurements",
						component: BessAssetMeasurements
					}
				]
			},
			{
				name: "bess-alerts",
				path: "/bess/alerts",
				component: BessAlerts
			}
			// --- END BESS routes ---
		]
	},
	{
		path: "/asset-energy-panel",
		name: "asset-energy-panel",
		component: AssetEnergyPanel
	},
	{
		path: "/report-viewer",
		name: "report-viewer",
		component: ReportViewer
	}
];

const router = createRouter({
	history: createWebHistory(),
	routes
});

export default router;
